<template>
  <div class="container-fluid">
    <h1 class="detail-title">
      <i id="sidebar" class="fa fa-bars sidebar" @click="toggleSidebar"></i>
      Create MEA
    </h1>
    <div id="card">
      <div class="card-section">
        <popups></popups>  
        <div class="row section-body">
          <div class="col-sm-3 section-property-block">
            <p class="section-property-title">Name</p>
            <input id="mea-name" type="text" name="name" required/>
          </div>
          
          <div class="col-sm-3 section-property-block">
            <p class="section-property-title">Pick A Color</p>
            <div class="input-group color-picker" ref="colorpicker">
            	<input type="text" v-model="colorValue" disabled @focus="showPicker()" @input="updateFromInput" />
            	
              <span class="input-group-addon color-picker-container">
            		<span class="current-color" :style="'background-color: ' + colorValue" @click="togglePicker()"></span>
            		<chrome-picker :value="colors" @input="updateFromPicker" v-if="displayPicker" />
            	</span>
            </div>
          </div>
        </div>
        <div class="row section-body">
          <div class="col-sm-3 section-property-block">
            <p class="section-property-title">Abbreviation</p>
            <input type="text" id="mea-abbreviation" name="abbreviation"/>
          </div>
        </div>
        
        <div class="row section-body">
          <div class="col-sm-6 section-property-block">
            <p class="section-property-title">Description</p>
            <textarea id="mea-description" type="text" name="description"></textarea>
          </div>
        </div>
      </div>

      <div class="row section-body">
          <div class="col-sm-6 section-property-block">
              <p class="section-property-title">Document</p>
              <input id="mea-document" type="file" name="document"></input>
          </div>
      </div>
     
      <div class="card-section sub-section">
        <div class="row">
          <div class="col-sm-3">
            <h1 class="section-title">Categories</h1>
          </div>
        </div>
        <div class="row section-body contact" >
          <div class="col-sm-3 section-property-block">
            <p class="section-property-title">Name</p>
            <input type="text" placeholder="Enter value" v-model="category"/>
          </div>
          <div class="col-sm-4 section-property-block">
            <div :class="['plus category-action category-add', !category? 'disabled': '']" @click="addCategory">
              <img src="../../assets/plus.svg" alt="">
            </div>
          </div> 
        </div>
        <div class="row section-body contact" v-for="(category, index) in categories">
          <div class="col-sm-3 section-property-block">
            <p class="section-property-title">Name</p>
            <input :id="'value-'+ index" :ref="'value-'+ index"
                type="text" :name=" 'category-'+index"
                placeholder="Enter value" :value="category.name" disabled />
          </div>
          <div class="col-sm-4 section-property-block">
            <div class="minus category-action category-delete" @click="rmvCategory(index)">
              <img src="../../assets/letter-x.svg" alt="">
            </div>
          </div> 

        </div>
      </div>
      
      <div class="card-section sub-section">
        <div class="row section-body button">
          <div class="col-sm-3 section-property-block">
            <btn type="primary" @click="submitMea()">Create</btn>
          </div>
        </div>
      </div>
    </div>      
  </div>
</template>

<script type="text/javascript">
import { mapState, mapGetters } from 'vuex';
import moment from 'moment';
import store from '../../store.js';
import constants from '../../constants';
import Popups from '../Popups';
import { MultiSelect } from 'uiv';
import { bus } from '../../main';
import { Chrome } from 'vue-color';

export default {
  props: ['color'],
  data () {
      return {
        colors: { },
  			colorValue: '',
  			displayPicker: false,
        errors: [],
        message: {type: 'warning', title: 'MEA'},
        contact_fields: [['name']],
        categories: [],
        category: ''
      };
  },
  computed: {
    ...mapGetters([ 'hasErrors', 'getErrors', 'resetErrors' ]),
    ...mapState({
      // Extract things like this out into a Mixin
      organizations: function (state) {
        return state.organizations;
      },
    }),
  },
  methods: { 
    toggleSidebar(){
      bus.$emit('toggle-sidebar');
    },
      
    redirect: function(action) {
      if (action == 'success') this.$router.push('/meas');
    },

    addCategory: function(){
      if(this.category){
        let category = {
          name: this.trimValue(this.category),
        }
        this.categories.push(category);
        this.category = '';
      } else {
        this.showPopup(
          {
            'type': 'warning', 
            'title': 'Category',
            'content': 'A category name is required!'
          }, 'notification');
      }
    },

    rmvCategory: function(index){
      this.$confirm({
          title: 'Confirm Action',
          content: 'Are you sure you want to remove this category?',
        }).then(() => {
          this.categories.splice(index, 1);
          }).catch(() => {
            this.$notify('Request has been cancelled.')
          });
    },

    reset: function() {
      this.errors = [];
      bus.$emit('reset', {});
    },
    
    trimValue: function(value) {
      return (value != undefined || value != null)? value.trim() : value;
    },
    
    showPopup: function(value, type) {
      bus.$emit(type, { data: value });
      this.redirect(value.type)
    },
    
    resetTemplate: function() {
      this.clearFields(document.getElementById('card'));
    },
    
    clearFields: function(element) {
      for (var i = 0; i < element.childNodes.length; i++) {
         var e = element.childNodes[i];
         if (e.tagName) switch (e.tagName.toLowerCase()) {
            case 'input':
               switch (e.type) {
                  case "radio":
                  case "checkbox": e.checked = false; break;
                  case "button":
                  case "submit":
                  case "image": break;
                  default: e.value = ''; break;
               }
               break;
            case 'select': e.selectedIndex = 0; break;
            case 'textarea': e.value = ''; break
            default: this.clearFields(e);
         }
      }
    },
    
    createMea: async function(data) {
      let failed = constants.message.create.failed;
      let success = constants.message.create.success;
      let response  = await store.dispatch('createMea', { mea: data });       

      if(response != null){
        this.message.type = 'success';
        this.message.content = success;
      } else this.message.content = failed;
      this.showPopup(this.message, 'notification');
    },
    
    submitMea: function() {
      // reset error message and popup 
      this.reset();
      
      let color = this.colorValue;

      let name = $("#mea-name").val();
      let description = $("#mea-description").val();
      let MeaDoc = $("#mea-document").val();
      let abbreviation = $("#mea-abbreviation").val();
      let status = $("#mea-status option:selected").val();
            
      if (name.length < 1) {
        this.errors.push('Name is required');
      }
      if (abbreviation.length < 1) {
        this.errors.push('Abbreviation is important');
      }
      if (color.length < 1) {
        this.errors.push('Please assign a color to MEA');
      } else {
        let regex = /(^#[0-9A-Fa-f]{6}$)|(^#[0-9A-Fa-f]{3}$)/;
        if(!regex.test(color)) {
          this.errors.push('Invalid, Only hex-color value is accepted (eg. #ff4000, #FFFFFF etc)');
        }
      }
              
      //get important field values from user options

      if (this.errors.length > 0) this.showPopup({'content': this.errors }, 'alert');
      else {
        this.createMea(
          {
            'name': this.trimValue(name), 
            'status': status, 
            'color': color,
            'abbreviation': this.trimValue(abbreviation),
            'description': this.trimValue(description),
            'document': MeaDoc,
            'categories': this.categories
          }
        ); 
      }
    },
    
    setColor(color) {
			this.updateColors(color);
			this.colorValue = color;
		},
    
		updateColors(color) {
			if(color.slice(0, 1) == '#') {
				this.colors = {
					hex: color
				};
			}
			else if(color.slice(0, 4) == 'rgba') {
				var rgba = color.replace(/^rgba?\(|\s+|\)$/g,'').split(','),
					hex = '#' + ((1 << 24) + (parseInt(rgba[0]) << 16) + (parseInt(rgba[1]) << 8) + parseInt(rgba[2])).toString(16).slice(1);
				this.colors = {
					hex: hex,
					a: rgba[3],
				}
			}
		},
    
		showPicker() {
			document.addEventListener('click', this.documentClick);
			this.displayPicker = true;
		},
    
		hidePicker() {
			document.removeEventListener('click', this.documentClick);
			this.displayPicker = false;
		},
    
		togglePicker() {
			this.displayPicker ? this.hidePicker() : this.showPicker();
		},
    
		updateFromInput() {
			this.updateColors(this.colorValue);
		},
    
		updateFromPicker(color) {
			this.colors = color;
			if(color.rgba.a == 1) {
				this.colorValue = color.hex;
			}
			else this.colorValue = 'rgba(' + color.rgba.r + ', ' + color.rgba.g + ', ' + color.rgba.b + ', ' + color.rgba.a + ')';
		},
    
		documentClick(e) {
			var el = this.$refs.colorpicker,
				target = e.target;
			if(el !== target && !el.contains(target)) {
				this.hidePicker()
			}
		}    
  },
    
  watch: {
		colorValue(val) {
			if(val) {
				this.updateColors(val);
				this.$emit('input', val);
			}
		}
	},
  
  mounted() {
		this.setColor(this.color || '#F35807');
	},
  
  components: {
    Popups,
    MultiSelect,
    'chrome-picker': Chrome,
  },
  
  beforeRouteEnter (to, from, next) {
    next();
  }
};
</script>

<style scoped lang="scss">
@import "../../css/constants";

.input-group input{ margin-right: 0px; }
.input-group-addon:last-child { 
  margin-left: 5px; 
  border-left: 1px solid #ccc; 
  border-radius: 4px; 
}

.vc-chrome {
	position: absolute;
	top: 35px;
	right: 0;
	z-index: 9;
}

.current-color {
	display: inline-block;
	width: 16px;
	height: 16px;
	background-color: #000;
	cursor: pointer;
}

.category-action{
  color: #06bafc;
}

.category-add{
  margin-top: 40px;
  display: inline-block;
}

.disabled{
  color: red;
}

h1.detail-title{
    background-color: #04bafc;
    padding: 20px;
    margin-left: -40px;
    margin-right: -40px;
    color: white;
    height: auto;
    margin-bottom: 25px;
}

.category-delete{
  display: inline-block;
  margin-top: 40px;
}

/* body select.select_box option */
body select option { padding: 0 4px; }
/* for IE and Edge */
select::-ms-expand { display: none; }
select:disabled::-ms-expand { background: #f60; }
.tool-tip{
  display: none;
  color: grey;
  background-color: #ececec;
  border-radius: 4px;
  position:absolute;
  margin-top: -40px;
  width: fit-content;
  padding-top:5px;
  padding-bottom:5px;
  padding-left: 5px;
  padding-right:5px;
  z-index: 100;
}
.tool-tip::after{
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #ececec transparent transparent transparent;
}
.ellipsis {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.section-property:hover{
  display: block;
}
.container-fluid {
    padding: auto;
}
.card-section {
  display: flex;
  flex-direction: column;
}

.card-sub-body {
  margin-top: 20px !important;
  border-top: 1px solid #ddd;
  padding: 25px 0 0 0;
}

.section-body { display: flex; flex-wrap: wrap; }
.sub-section { margin-top: 25px; }
.section-title {
    color: $gray7;
    font-size: 20px;
    line-height: $p20;
    margin-bottom: $p24;
}
.section-property-block {
  margin-right: $p16;
	margin-bottom: $p16;
	// min-width: 140px;
}
.section-property-title {
    position:relative;
    z-index:1;
    color: $gray5;
    text-transform: uppercase;
    margin-bottom: $p16;
    font-size: 14px;
    line-height: $p14;
}
.section-property-container {
  height: $p32;
}
.section-property {
    color: #7b7b7b;
    border:none;
    word-wrap: break-word;
    cursor: pointer;
    width: 100%;
    font-size: 14px;
}
.detail-card-body{
    background-color: white;

}
@media (min-width: 576px){
  .col-sm-2 {
    max-width: 15.666667%;
  }
}
//Reset Grid
.col-lg-1, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg-2, .col-lg-3, .col-lg-4,
.col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-md-1, .col-md-10,
.col-md-11, .col-md-12, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6,
.col-md-7, .col-md-8, .col-md-9, .col-sm-1, .col-sm-10, .col-sm-11, .col-sm-12,
.col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8,
.col-sm-9, .col-xs-1, .col-xs-10, .col-xs-11, .col-xs-12, .col-xs-2, .col-xs-3,
.col-xs-4, .col-xs-5, .col-xs-6, .col-xs-7, .col-xs-8, .col-xs-9 {
  padding: 0;
}
//Reset row
.row {
  margin: 0;
}
.minus, .plus{
  border: 1px solid #cfcfcf;
  height: 35px;
  width: 35px;
  border-radius: 50%;
  display: flex;
  margin-top: 5px;
  cursor: pointer;
  margin-top: 30px;
  margin-left: 10px;
}

.minus { margin-top: 20px; }
.minus > img, .plus > img{
  margin: auto;
}

  button.save {
    width: 100px;
    height: $p32;
    border: 1px solid $gray4;
    border-radius: 4px;
    background-color: white;
    font-size: $p14;
    color:grey;
    &:focus {
      outline: none;
    }
  }
  
  @media only screen and (min-width: 768px) {
    /* For mobile phones: */
    h1.detail-title {
      padding-left: 45px;
    }
  }

  @media only screen and (min-width: 468px) and (max-width: 768px) {
    /* For mobile phones: */
    h1.detail-title {
      padding-left: 45px;
      i { display: inline-block; margin-right: 15px;  }
    }
  }

  @media only screen and (max-width: 467px) {
    /* For mobile phones: */
    h1.detail-title {
      padding-left: 45px;
      i { display: inline-block; margin-right: 15px; }
    } 
  }
</style>



// WEBPACK FOOTER //
// src/components/mea/CreateMea.vue